export const blockIconsPrivacyandsecurityPolicyNew = (
	<span className='material-symbols-outlined'>policy</span>
);
